import React from 'react'
import heroMainBackgroundMobile from '../images/mobile.png'
import backgroundDesktop from '../images/desktop.png'
 


const HeroSection = (props) => {
    return (

        <section className="hero-section">
            <div className="top-content">
                <img src={heroMainBackgroundMobile} className="fade-in mobile-only" alt="" />
                <img src={backgroundDesktop} className="fade-in desktop-only" alt="" />
                <h1>אוטו השנה 2023</h1>
            </div>
            <div className="vote-content">

                <div className="details">
                    <h2>{props.headerTitleText}</h2>
                    <p>{props.headerDescription}
                    
                    </p>
                </div>
            </div>
        </section>

    )
}

export default HeroSection
